<template>
    <div class="d-flex flex-row mx-2 align-center">
        <div class="flex-grow-1 flex-shrink-1"/>
        <div class="flex-grow-0 flex-shrink-0 d-flex flex-row mx-2 align-center">
            <label class="mx-4">每页数目:</label>
            <v-select :items="items" label="" v-model="pageSize" class="select py-0 my-1" @change="pageSizeChanged"></v-select>
            <label  class="mx-4">{{getFromRowNo()}} - {{getToRowNo()}} 共 {{total}}</label>
            <v-btn small dense fab @click="prevPageClicked()" :disabled="getPrevPageDisabled()"  class="mx-2 " depressed>
                <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn small dense fab @click="nextPageClicked()" :disabled="getNextPageDisabled()"  class="mx-2" depressed> 
                <v-icon >mdi-chevron-right</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Pagination',
    props:{
        initPageSize:{
            type:Number,
            default:0,
        },
        total:{
            type:Number,
            default:0,
        },
        items:{
            type:Array,
            default:[],
        },
        outlined:{
            type:Boolean,
            default:false,
        },
        dense:{
            type:Boolean,
            default:false,
        },
        
    },
    data () {
        return {
            pageNo:0,
            pageSize:0,
        }
    },
    
    methods:{

        setPageNo(pageNo){
            let me = this;
            if((pageNo>=0)&&(pageNo!=me.pageNo)){
                me.pageNo = pageNo;
                me.$emit('update:pageNo',me.pageNo);
            }
        },

        getPagesTotal(){
            let me = this;
            if(me.total>0 && me.pageSize>0){
               return Math.ceil(me.total/me.pageSize);
            }
            return  0;
        },

        getFromRowNo(){
            let me = this;
            if((me.total<=0) || (me.pageSize<=0) || (me.pageNo<=0))
                return '';
            return me.pageSize*(me.pageNo-1)+1;
        },

        getToRowNo(){
            let me = this;
            if((me.total<=0) || (me.pageSize<=0) || (me.pageNo<=0))
                return '';
            let to = me.pageSize*me.pageNo;
            return to>me.total?me.total:to;
        },

        getPrevPageDisabled(){
            if((this.pageNo<=1)||(this.getPagesTotal()<=1))
                return true;
            return false;
        },

        getNextPageDisabled(){
            if((this.pageNo>=this.getPagesTotal())||(this.getPagesTotal()<=1))
                return true;
            return false;
        },

        prevPageClicked(){
            if(this.getPrevPageDisabled())
                return;
            this.setPageNo(this.pageNo-1);
        },

        nextPageClicked(){
            if(this.getNextPageDisabled())
                return;
            this.setPageNo(this.pageNo+1);
        },

        pageSizeChanged(){
            this.firePageSizeChange();
            this.refreshPageNo();
        },
        firePageSizeChange(){
            let me = this;
            me.$emit('update:pageSize',me.pageSize);
        },
        setPageSize(pageSize){
            if(pageSize!=this.pageSize){
                this.pageSize=pageSize;
                this.firePageSizeChange();
            }
        },
        refresh(){
            this.refreshPageSize();
            this.refreshPageNo();
        },
        refreshPageSize(){
            if((!this.pageSize)||this.pageSize<=0){
                if((!this.items)||(!this.items.length)||(this.items.length<1)){
                    if(this.initPageSize && this.initPageSize>0){
                        this.setPageSize(this.initPageSize);
                    }else{
                        this.setPageSize(10);
                    }
                }else{
                    if(this.initPageSize && this.initPageSize>0){
                        if(!this.items.indexOf(this.initPageSize)!=-1)
                            this.setPageSize(this.initPageSize);
                        else
                            this.setPageSize(this.items[0]);
                    }else{
                        this.setPageSize(this.items[0]);
                    }
                }
                    
            }else{
                if(this.items&& this.items.length && this.items.indexOf(this.pageSize)==-1){
                    this.setPageSize(this.items[0]);
                }
            }
        },
        refreshPageNo(){
            if((this.total>0)&&(this.pageSize>0)&&((Math.ceil(this.total/this.pageSize)<this.pageNo)||(this.pageNo==0)))
                this.setPageNo(1);
        }
    },
    mounted(){
    },
    created(){
        this.refresh();
    },
    computed:{
        
    },
    watch: {
       
        items:function(newItems){
            this.refresh();
        },
        total:function(newTotal){
            this.refresh();
        },
        initPageSize:function(){
            this.refresh();
        }

    }
}
</script>
<style scoped>

    .menu{
        width:100%;
    }

    .text-field{
        width:100%;
    }

    .menu-content{
        background: white;
    }

    .select{
        max-width: 60px;
    }

</style>
